export default __webpack_public_path__ + "static/media/shape6.08b21649.svg";